import { isNumber } from 'lodash-es';

import { defaultRatio } from '../constants.js';
import { LegendRatio } from '../types/legend.js';

export const DEFAULT_PIE_LEGEND_RATIO = 25;

const LEGEND_RATIO_RANGE: { min: number; max: number } = {
  min: 5,
  max: 80,
};

/**
 * Returns the value of the ratio if it is in the range of allowed values (5-80), otherwise it will return the default ratio
 * @param legendRatio -
 */
export const sanitizeLegendRatio = (
  legendRatio: LegendRatio = defaultRatio,
): number =>
  !isNumber(legendRatio) ||
  legendRatio < LEGEND_RATIO_RANGE.min ||
  legendRatio > LEGEND_RATIO_RANGE.max
    ? DEFAULT_PIE_LEGEND_RATIO
    : (legendRatio as number);
